// src/components/Skills.js

import React from "react";

// Import your custom SVG icons (replace with actual paths)
import NodeIcon from "../../icons/node.svg";
import ReactIcon from "../../icons/react.svg";
import MongoDBIcon from "../../icons/mongodb.svg";
import HtmlIcon from "../../icons/html.svg";
import CssIcon from "../../icons/css.svg";
import JsIcon from "../../icons/js.svg";
import BootstrapIcon from "../../icons/bootstrap.svg";
import TailwindIcon from "../../icons/tailwind.svg";
import GitIcon from "../../icons/git.svg";
import FirebasIcon from "../../icons/firebase.svg";
import NetlifyIcon from "../../icons/netlify.svg";
import StripeIcon from "../../icons/stripe.svg";

const Skills = () => {
  return (
    <div className="  w-full mx-auto text-center p-8 mt-12">
      <h2 className="text-5xl font-semibold mb-4">My Skills</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4  place-items-center ">
        {/* Node.js */}
        <div className="flex items-center space-x-2">
          <img src={NodeIcon} alt="Node.js" className="w-6 h-6" />
          <span>Node.js</span>
        </div>
        {/* React.js */}
        <div className="flex items-center space-x-2">
          <img src={ReactIcon} alt="React.js" className="w-6 h-6" />
          <span>React.js</span>
        </div>
        {/* MongoDB */}
        <div className="flex items-center space-x-2">
          <img src={MongoDBIcon} alt="MongoDB" className="w-6 h-6" />
          <span>MongoDB</span>
        </div>
        {/* Code */}
        <div className="flex items-center space-x-2">
          <img src={HtmlIcon} alt="HTML, CSS, JS" className="w-6 h-6" />
          <span>HTML</span>
        </div>
        <div className="flex items-center space-x-2">
          <img src={CssIcon} alt="HTML, CSS, JS" className="w-6 h-6" />
          <span> CSS</span>
        </div>
        <div className="flex items-center space-x-2">
          <img src={JsIcon} alt="HTML, CSS, JS" className="w-6 h-6" />
          <span> JS</span>
        </div>
        <div className="flex items-center space-x-2">
          <img src={BootstrapIcon} alt="HTML, CSS, JS" className="w-6 h-6" />
          <span>Bootstrap</span>
        </div>
        <div className="flex items-center space-x-2">
          <img src={TailwindIcon} alt="HTML, CSS, JS" className="w-6 h-6" />
          <span>Tailwind</span>
        </div>
        <div className="flex items-center space-x-2">
          <img src={GitIcon} alt="HTML, CSS, JS" className="w-6 h-6" />
          <span>Git</span>
        </div>
        <div className="flex items-center space-x-2">
          <img src={FirebasIcon} alt="HTML, CSS, JS" className="w-6 h-6" />
          <span>Firebase</span>
        </div>
        <div className="flex items-center space-x-2">
          <img src={NetlifyIcon} alt="HTML, CSS, JS" className="w-6 h-6" />
          <span>Netlify</span>
        </div>
        <div className="flex items-center space-x-2">
          <img src={StripeIcon} alt="HTML, CSS, JS" className="w-6 h-6" />
          <span>Stripe</span>
        </div>

        {/* Add more skills/icons as needed */}
      </div>
    </div>
  );
};

export default Skills;
